module.exports = __webpack_public_path__ + "img/OverlayIcon-BestWeekly.523c3f92.png";